import { createFileRoute } from "@tanstack/react-router";

import { bgLinearGradient } from "@/app/types/ui";
import { MimiatHorizontalLogo } from "@/components/shared/MimiatHorizonalLogo";

import errorImg from "@/assets/reset-password/forgot-password-image.svg";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { useTranslation } from "react-i18next";
import { Paragraph } from "@/components/ui/typography/Paragraph";
import { SupportEmailLink } from "@/components/ui/external-links/SupportEmailLink";

export const Route = createFileRoute("/error/disabled")({
  component: DisabledError,
});

function DisabledError() {
  const { t } = useTranslation();

  return (
    <div className={`${bgLinearGradient} min-h-screen overflow-hidden`}>
      <div className="mt-12 flex flex-col items-center">
        <div className="mx-auto mb-8 xl:mb-20">
          <MimiatHorizontalLogo />
        </div>
        <div className="flex gap-8 items-center lg:max-w-3xl xl:max-w-4xl">
          <img src={errorImg} alt="Error img" />
          <div className="flex flex-col gap-4">
            <HeadingOne>{t("disabled_error.title")}</HeadingOne>
            <Paragraph>
              {t("disabled_error.text")} <SupportEmailLink />.
            </Paragraph>
          </div>
        </div>
      </div>
    </div>
  );
}
